import { ReactNode } from 'react'

import { ExplorerDataType, getExplorerLink, shortenAddress } from '@cowprotocol/common-utils'
import { isSupportedAddress } from '@cowprotocol/cow-sdk'

import styled from 'styled-components/macro'

const Link = styled.a`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

interface AddressLinkProps {
  address: string
  chainId: number
  className?: string
  content?: string
}

export function AddressLink({ address, chainId, className, content }: AddressLinkProps): ReactNode {
  return isSupportedAddress(address) ? (
    <Link
      className={className}
      href={getExplorerLink(chainId, address, ExplorerDataType.ADDRESS)}
      target="_blank"
      rel="noreferrer"
    >
      {content ? (isSupportedAddress(content) ? shortenAddress(content) : content) : shortenAddress(address)} ↗
    </Link>
  ) : (
    address
  )
}
